import React from 'react'
import { Routes, Route, Link } from 'react-router-dom';
import Higher from '../Basics/Higher'
import Summer from '../Basics/Summer'
import Placement from '../Basics/Placement'
import Major from '../Basics/Major'
import Home from  '../Basics/Home'
import Summer_2021 from '../2021/Summer_2021';
import Summer_2022 from '../2022/Summer_2022';
import Summer_2023 from '../2023/Summer_2023';
import Summer_2020 from '../2020/Summer_2020';
import Placement_2023 from '../2023/Placement_2023'
import Placement_2022 from '../2022/Placement_2022'
import Placement_2021 from '../2021/Placement_2021'
import Placement_2020 from '../2020/Placement_2020'
import Summer_2024 from '../2024/Summer_2024';
import Major_2020 from '../2020/Major_2020'
import Major_2021 from '../2021/Major_2021'
import Major_2022 from '../2022/Major_2022'
import Major_2023 from '../2023/Major_2023'
import Higher_2023 from '../2023/Higher_2023'
import Higher_2022 from '../2022/Higher_2022'
import Higher_2021 from '../2021/Higher_2021'
import Higher_2020  from '../2020/Higher_2020'
import Minor from './Minor';
import ImageGallery from './ImageGallery';


const Card = () => {
  return (
    <div className='mybackcard'>

        <div className="card shadow">
       

        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hs" element={<Higher />} >
              <Route exact path="2023" element={<Higher_2023 />} />
              <Route exact path="2022" element={<Higher_2022 />} />
              <Route exact path="2021" element={<Higher_2021 />} />
              <Route exact path="2020" element={<Higher_2020 />} />
            </Route>
            <Route path="/sp" element={<Summer/>}>
              <Route exact path="2024" element={<Summer_2024 />} />
              <Route exact path="2023" element={<Summer_2023 />} />
              <Route exact path="2022" element={<Summer_2022 />} />
              <Route exact path="2021" element={<Summer_2021 />} />
              <Route exact path="2020" element={<Summer_2020 />} />

            </Route>
            <Route path="/minor" element={<Minor/>}>
            </Route>

            <Route path="/place" element={<Placement />}>
              <Route exact path="2023" element={<Placement_2023/>} />
              <Route exact path="2022" element={<Placement_2022/>} />
              <Route exact path="2021" element={<Placement_2021/>} />
              <Route exact path="2020" element={<Placement_2020/>} />
            </Route>
            <Route path="/mp" element={<Major />}>
              <Route exact path="2023" element={<Major_2023/>} />
              <Route exact path="2022" element={<Major_2022/>} />
              <Route exact path="2021" element={<Major_2021/>} />
              <Route exact path="2020" element={<Major_2020/>} />
            </Route>

            <Route path="/gallery" element={<ImageGallery/>}></Route>
        </Routes>

           
        </div>
    </div>
  )
}

export default Card